module.exports = __webpack_public_path__ + "static/media/hurricanes.0ca4fc3c.jpg";